import { useCallback } from 'react';
import { useAuth } from './useAuth';

export function useCurrency() {
  const { organization } = useAuth();
  
  // Default to JMD if no organization currency is set
  const currency = organization?.currency || 'JMD';
  
  const formatCurrency = useCallback((amount: number): string => {
    return new Intl.NumberFormat('en-JM', {
      style: 'currency',
      currency,
      minimumFractionDigits: currency === 'JMD' ? 0 : 2,
      maximumFractionDigits: currency === 'JMD' ? 0 : 2,
    }).format(amount);
  }, [currency]);

  return {
    currency,
    formatCurrency,
  };
}





